import dayjs from 'dayjs';
import * as z from 'zod';

import { isAfterDate, isValidCurrency } from '@/utils/validate';

import { teamFormFragmentSchema } from '../TeamFormFragment';

export type OnboardEmployeeSchema = z.infer<typeof schema>;

export const schema = z
  .object({
    firstName: z.string().min(1, 'Required'),
    lastName: z.string().min(1, 'Required'),
    email: z.string().min(1, 'Required').email(),
    countryCode: z.string().min(1, 'Required'),
    jobTitle: z.string().min(1, 'Required'),
    servicesDescription: z
      .string()
      .min(1, 'Required')
      .max(255, 'Description of services should be less than 256 characters'),
    startsAt: z
      .string()
      .min(1, 'Required')
      .refine((startsAt) => dayjs(startsAt).isAfter(dayjs()), 'Start date should be after today'),
    endsAt: z.string().optional(),
    quotedCurrencyCode: z.string().min(1, 'Required'),
    quotedGrossSalary: z
      .string()
      .min(1, 'Required')
      .refine((quotedGrossSalary) => Number(quotedGrossSalary) > 0, 'Must be a valid amount'),
    grossSalaryPeriod: z.string().min(1, 'Required'),
    bonusDays: z.string().min(1, 'Required').optional(),
    vacationDays: z.number().gte(6, 'Vacation days should be 6 or more').optional(),
    vacationsPremiumPercentage: z.string().min(1, 'Required').optional(),
    needsBenefits: z.string().min(1, 'Required'),
    newGroupBenefit: z.string().min(1, 'Required').optional(),
    pto: z.string().min(1, 'Required').optional(),
    dependentLife: z.boolean().optional(),
    health: z.boolean().optional(),
    dental: z.boolean().optional(),
    savingsFund: z.boolean().optional(),
    groceryAllowance: z.boolean().optional(),
    hasAuthority: z.boolean().refine((authority) => authority, 'Required'),
  })
  .merge(teamFormFragmentSchema)
  .refine(({ startsAt, endsAt }) => (endsAt ? isAfterDate(endsAt, startsAt) : true), {
    path: ['endsAt'],
    message: 'End date should be after start date',
  })
  .refine(
    ({ quotedGrossSalary, quotedCurrencyCode }) =>
      isValidCurrency(quotedGrossSalary, quotedCurrencyCode),
    {
      path: ['quotedGrossSalary'],
      message: 'Must be a valid amount',
    }
  );
